import { Theme } from "@material-ui/core/styles/createMuiTheme";
import makeStyles from "@material-ui/styles/makeStyles";
import axios from "axios";
import { clevertapTracking } from "clevertapTracking";
import Slide from "components/Slide";
import WarningModel from "components/WarningModel";
import {
  GET_ALL_BANNERS_OF_USER,
  GET_PLAN_DETAILS_BY_ID,
} from "graphql/profiles";
import {
  GetAllGroupBannersOfUser,
  GetAllGroupBannersOfUserVariables,
} from "graphql/types/GetAllGroupBannersOfUser";
import {
  GetPlanDetailsByPlanId,
  GetPlanDetailsByPlanIdVariables,
} from "graphql/types/GetPlanDetailsByPlanId";
import { UserState } from "graphql/types/globalTypes";
import { dataLayerTracking } from "gtmTracking";
import { clientRoutes } from "helpers/clientRoutes";
import { checkUserCircleSubscriptionActive } from "helpers/commonHelpers";
import { getCommonPatientAttributes } from "helpers/commonHelpers";
import {
  ICONS_PATHS,
  prohealth,
  PROHEALTH_BANNER_SOURCE,
} from "helpers/constants";
import { getPromotionEventsObject } from "helpers/gtmUtils";
import { useAuth } from "hooks/authHooks";
import useIntersection from "hooks/useObserver";
import dynamic from "next/dynamic";
import React, { useEffect, useState, useRef } from "react";
import { useApolloClient } from "react-apollo-hooks";
import { SignedinState } from "./enums/SignedinState";
import { useGlobalDiagnosticsCart } from "./Tests/DiagnosticsCartProviderGlobal";
const iconPathsCircleBlue = ICONS_PATHS.slice(0, 2);

const DynamicSlider = dynamic(
  () =>
    import("react-slick").then((defaultComponent) => defaultComponent.default),
  { ssr: false }
);

const useStyles = makeStyles((theme: Theme) => {
  return {
    slider: {
      padding: "10px 0",
      "& >.slick-list": {
        minHeight: 220,
        [theme.breakpoints.down("sm")]: {
          minHeight: 140,
        },
        "& .slick-track": {
          display: "flex",
        },
        "& .slick-slide": {
          width: "100%",
        },
      },
      "& >.slick-dots": {
        position: "static !important",
        margin: "0 0 0 40px",
        textAlign: "left",
        [theme.breakpoints.down("sm")]: {
          margin: 0,
          textAlign: "center",
        },
        "& li": {
          width: 10,
          height: 10,
          "& button": {
            display: "block",
            width: 8,
            height: 8,
            borderRadius: 8,
            background: "#C4C4C4",
            color: "transparent",
            "&:before": {
              display: "none",
            },
          },
          "&.slick-active": {
            width: 20,
            height: 8,
            "& button": {
              width: 20,
              height: 8,
              background: "#007C9D",
            },
          },
        },
      },
      "& .slick-arrow": {
        width: 44,
        height: 44,
        background: "#fff",
        borderRadius: "50%",
        zIndex: 9,
        boxShadow: " 0px 0px 12px rgba(0, 0, 0, 0.16)",
        display: "flex !important",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
          width: 40,
          height: 40,
        },
        [theme.breakpoints.down("xs")]: {
          display: "none !important",
        },
      },
      "& .slick-prev": {
        left: 0,
        "&:before": {
          content: "''",
          width: 12,
          height: 18,
          background: `url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/arrow-left.svg") no-repeat 0 0`,
        },
      },
      "& .slick-next": {
        right: 0,
        "&:before": {
          content: "''",
          width: 12,
          height: 18,
          background: `url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/arrow-right.svg") no-repeat 0 0`,
        },
      },
    },
    slickCase: {
      padding: 20,
      "&:focus": {
        outline: 0,
      },
      [theme.breakpoints.down("sm")]: {
        padding: 10,
      },
      [theme.breakpoints.down("xs")]: {
        display: "flex",
        alignItems: "center",
        justifycontent: "center",
        padding: 0,
      },
    },
    card: {
      boxShadow: " 0px 5px 20px rgba(128, 128, 128, 0.3)",
      borderRadius: 10,
      height: 172,
      "&:focus": {
        outline: 0,
      },
      [theme.breakpoints.down("sm")]: {
        height: 125,
        // backgroundSize: "contain",
        boxShadow: "none",
        backgroundColor: "transparent !important",
      },
      [theme.breakpoints.down("xs")]: {
        height: 155,
      },
    },
    slide1: {
      background: `#fff url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/slide1.png") no-repeat 0 0`,
      [theme.breakpoints.down("sm")]: {
        backgroundSize: "contain",
      },
      [theme.breakpoints.down("xs")]: {
        background: `transparent url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/mweb_slide1.png") no-repeat center center`,
      },
    },
    slide2: {
      background: `#fff url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/slide2.png") no-repeat 0 0`,
      [theme.breakpoints.down("sm")]: {
        backgroundSize: "contain",
      },
      [theme.breakpoints.down("xs")]: {
        background: `url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/mweb_slide2.png") no-repeat  center center`,
      },
    },
    slide3: {
      background: `#fff url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/slide3.png") no-repeat 0 0`,
      [theme.breakpoints.down("sm")]: {
        backgroundSize: "contain",
      },
      [theme.breakpoints.down("xs")]: {
        background: `url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/mweb_slide3.png") no-repeat  center center`,
      },
    },
    slide4: {
      background: `#fff url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/slide4.png") no-repeat 0 0`,
      [theme.breakpoints.down("sm")]: {
        backgroundSize: "contain",
      },
      [theme.breakpoints.down("xs")]: {
        background: `url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/banners/mweb_slide4.png") no-repeat  center center`,
      },
    },
    connectDoctorContent: {
      display: "flex",
      alignItems: "flex-start",
      flexWrap: "wrap",
    },
    cdDetails: {
      width: "50%",
      padding: 12,
      "& img": {
        margin: "0 auto 10px",
      },
      "& h5": {
        fontSize: 12,
        color: "#00B38E",
        linHeight: "16px",
        "& span": {
          fontWeight: 700,
        },
      },
    },
    dialogContent: {},
    dialogHeader: {
      padding: "16px 16px 10px",
      "& h3": {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: "21px",
      },
      "& p": {
        fontSize: 10,
        lineHeight: "13px",
      },
    },
    btnContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "10px 16px 16px",
      "& button": {
        margin: "0 0 0 10px",
        "&:first-child": {
          boxShadow: "none",
          color: "#FC9916",
        },
      },
    },
    p0: {
      padding: 0,
    },
    callNote: {
      fontSize: 12,
      linrHeight: "16px",
      "& span": {
        display: "block",
      },
    },
    bannerLogo: {
      margin: "15px 0 5px 0",
      fontWeight: 500,
      [theme.breakpoints.down("xs")]: {
        paddingRight: 10,
      },
      "& img": {
        display: "inline-block",
        verticalAlign: "middle",
        [theme.breakpoints.down("xs")]: {
          maxWidth: 54,
        },
      },
    },
    upgradeContainer: {
      fontSize: 16,
      height: 28,
      [theme.breakpoints.down("xs")]: {
        fontSize: 13,
      },
      "& img": {
        maxWidth: 60,
        display: "inline-block",
        verticalAlign: "middle",
        marginLeft: 5,
        [theme.breakpoints.down("xs")]: {
          maxWidth: 44,
        },
      },
    },
    sliderContainer: {},
  };
});

type CircleSliderProps = {
  banners: any;
  setBanners: (obj) => void;
};

const CircleSlider: React.FC<CircleSliderProps> = (props) => {
  const { banners, setBanners } = props;
  const classes = useStyles({});
  const { currentPatient } = useAuth();
  const { diagnosticAddress } = useGlobalDiagnosticsCart();
  const proHealthRef = useRef<HTMLDivElement>(null);
  const isRefVisible = useIntersection(proHealthRef);
  const [isUserCare, setIsUserCare] = useState<boolean>(false);
  const [isUserHDFC, setIsUserHDFC] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const client = useApolloClient();
  const { isSignedIn } = useAuth();
  const [defaultCarePlanPrice, setDefaultCarePlanPrice] = useState<number>();
  const [showPharmaWebView, setShowPharmaWebView] = useState<boolean>(false);
  const [showTestsWebView, setShowTestsWebView] = useState<boolean>(false);
  const [landingPageName, setlandingPageName] = React.useState<string>("");
  const [successMessage, setSuccessMessage] = React.useState<object>();
  const [isProhealthBanner, setIsProhealthBanner] = useState<boolean>(false);
  const [isProhealthLogged, setIsProhealthLogged] = useState<boolean>(false);
  const [prohealthPosition, setProhealthPosition] = useState<number>(-1);

  useEffect(() => {
    const userSubscriptions: any = localStorage.getItem("userSubscriptions")
      ? JSON.parse(localStorage.getItem("userSubscriptions"))
      : {};
    setIsUserCare(checkUserCircleSubscriptionActive(userSubscriptions));
    setIsUserHDFC(
      userSubscriptions.HDFC &&
        userSubscriptions.HDFC.length > 0 &&
        userSubscriptions.HDFC[0].status == "active"
    );
  }, [isUserCare, currentPatient]);

  useEffect(() => {
    let banner_context = "HOME";
    if (window.location.pathname === clientRoutes.medicines()) {
      banner_context = "PHARMACY_HOME";
      setShowPharmaWebView(true);
      setShowTestsWebView(false);
      setlandingPageName(banner_context);
    } else if (window.location.pathname === clientRoutes.tests()) {
      banner_context = "DIAGNOSTIC_HOME";
      setShowTestsWebView(true);
      setShowPharmaWebView(false);
      setlandingPageName(banner_context);
    } else {
      setShowTestsWebView(false);
      setShowPharmaWebView(false);
      setlandingPageName(banner_context);
    }
    if (isSignedIn === SignedinState.SIGNEDIN) {
      client
        .query<GetAllGroupBannersOfUser, GetAllGroupBannersOfUserVariables>({
          query: GET_ALL_BANNERS_OF_USER,
          variables: {
            mobile_number: localStorage.getItem("mobile_num"),
            user_state:
              isSignedIn === SignedinState.SIGNEDIN
                ? UserState.LOGGED_IN
                : UserState.LOGGED_OUT,
            banner_context: banner_context,
          },
        })
        .then((response: any) => {
          setBanners(response.data.GetAllGroupBannersOfUser.response);
        })
        .catch((error: any) => {
          // console.error(error);
        })
        .finally(() => {
          // setLoading(false);
        });
    } else if (isSignedIn === SignedinState.SIGNEDOUT) {
      axios
        .get(
          `${process.env.NEXT_PUBLIC_247_CDN_URL}/files/GetAllGroupBannersOfUser.json`
        )
        .then((res: any) => {
          setBanners(res.data.data.GetAllGroupBannersOfUser.response);
        });
    }
  }, [isSignedIn]);

  useEffect(() => {
    if (isSignedIn === SignedinState.SIGNEDIN) {
      setLoading(true);
      if (!isUserCare) {
        client
          .query<GetPlanDetailsByPlanId, GetPlanDetailsByPlanIdVariables>({
            query: GET_PLAN_DETAILS_BY_ID,
            variables: {
              plan_id: "CIRCLEPlan",
            },
          })
          .then((response) => {
            if (
              response !== null &&
              response.data!.GetPlanDetailsByPlanId!.response !== null
            ) {
              response.data!.GetPlanDetailsByPlanId!.response!.plan_summary.map(
                (item: any) => {
                  if (item.defaultPack == true) {
                    setDefaultCarePlanPrice(item.currentSellingPrice);
                    localStorage.setItem("defaultPack", JSON.stringify(item));
                  }
                }
              );
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, [isUserCare, isSignedIn]);

  const renderBannerText = (str: string, button: boolean = false) => {
    if (str && str.includes("<circle>")) {
      const arrayOfStrings = str.split(" ");
      var headerText = arrayOfStrings.map((str, i) => {
        if (str == "<circle>") {
          return button ? (
            <img
              src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/circle.png`}
              alt="Circle Logo"
              style={{ marginLeft: 3 }}
            />
          ) : (
            <span
              className="icon-logo_circle_blue"
              style={{
                margin: "0px 5px 0px 5px",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            >
              {iconPathsCircleBlue.map((item, index) => {
                return <span key={index} className={item}></span>;
              })}
            </span>
          );
        } else {
          return " " + str;
        }
      });
      return <>{headerText}</>;
    }
    return str;
  };

  const sliderSettings = {
    infinite: true,
    dots: banners.length > 1 ? true : false,
    arrows: banners.length > 1 ? true : false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoPlaySpeed: 4000,
    autoplay: true,
    className: classes.slider,
    onInit: () => {
      const banner = banners[0]?.cta_action?.url?.includes(prohealth);
      if (banner) {
        setProhealthPosition(1);
        setIsProhealthBanner(true);
      } else {
        setIsProhealthBanner(false);
      }
    },
    beforeChange: (_, idx) => {
      const banner = banners[idx]?.cta_action?.url?.includes(prohealth);
      if (banner) {
        setProhealthPosition(idx + 1);
        setIsProhealthBanner(true);
      } else {
        setIsProhealthBanner(false);
      }
    },
  };

  useEffect(() => {
    if (isProhealthBanner && isRefVisible && !isProhealthLogged) {
      setIsProhealthBanner(false);
      // check if div is in viewport and thn log the event
      // once logged setIsProhealthLogged event to false
      // as we have to log event only once on page load and is in viewport

      const clevertapData = {
        ...getCommonPatientAttributes(currentPatient),
        "Patient city": diagnosticAddress?.cityName,
        "Banner source": PROHEALTH_BANNER_SOURCE.HOME_CAROUSEL,
        "Banner Position": prohealthPosition,
        City: diagnosticAddress?.cityName || "Not available",
        CityId: diagnosticAddress?.cityID || "Not available",
      };
      clevertapTracking("Prohealth banner viewed", clevertapData);
      setIsProhealthLogged(true);
    }
  }, [isRefVisible, isProhealthBanner, isProhealthLogged]);

  const handleClickBannerItems = (item, index) => {
    const creative_name = item?.banner?.split("/").slice(-1)[0].split(".")[0];
    const promotion_name = item?.banner;
    const event = getPromotionEventsObject(
      "select_promotion",
      "Apollo247 HomePage",
      "Apollo247 HomePage",
      creative_name,
      index + 1,
      "NA",
      promotion_name
    );
    dataLayerTracking(event);
  };

  return (
    <div
      id="slickContainer"
      className={classes.sliderContainer}
      ref={proHealthRef}
    >
      {/* @ts-ignore */}
      <DynamicSlider {...sliderSettings}>
        {banners &&
          banners.map((item: any, index: number) => {
            if (item.banner_display_type === "banner") {
              return (
                <div
                  onClick={() => handleClickBannerItems(item, index)}
                  className={classes.slickCase}
                >
                  <Slide
                    bannerInfo={item?.meta?.internalPromotion}
                    position={index}
                    key={`${index}_${item.banner_context}`}
                    bgRegular={item.banner}
                    button={
                      item.banner_template_info &&
                      item.banner_template_info.Button
                    }
                    buttonLeadText={renderBannerText(
                      item.banner_template_info &&
                        item.banner_template_info.Button,
                      true
                    )}
                    buttonSubText={
                      item.banner_template_info &&
                      item.banner_template_info.ButtonSubText
                    }
                    headLine={renderBannerText(
                      item.banner_template_info &&
                        item.banner_template_info.headerText1
                    )}
                    headLine2={renderBannerText(
                      item.banner_template_info &&
                        item.banner_template_info.headerText2
                    )}
                    headLine3={renderBannerText(
                      item.banner_template_info &&
                        item.banner_template_info.headerText3
                    )}
                    subHeaderText1={renderBannerText(
                      item.banner_template_info &&
                        item.banner_template_info.subHeaderText1
                    )}
                    subHeaderText2={renderBannerText(
                      item.banner_template_info &&
                        item.banner_template_info.subHeaderText2
                    )}
                    buttonAction={
                      item.cta_action &&
                      item.cta_action.meta &&
                      item.cta_action.meta.action
                    }
                    buttonActionType={item.cta_action && item.cta_action.type}
                    buttonURL={item.cta_action && item.cta_action.url}
                    subText={
                      item.banner_template_info &&
                      item.banner_template_info.fineText
                    }
                    showTestsWebView={showTestsWebView}
                    showPharmaWebView={showPharmaWebView}
                    defaultCarePlanPrice={defaultCarePlanPrice}
                    isUserCare={isUserCare}
                    landingPageName={landingPageName}
                    setSuccessMessage={setSuccessMessage}
                  />
                </div>
              );
            }
          })}
      </DynamicSlider>
      <WarningModel
        error={successMessage}
        onClose={() => {
          setSuccessMessage(null);
        }}
      />
    </div>
  );
};

export default CircleSlider;
